import { column, edge, flow, makeFlow, node } from "../builders";
import type { TemplateDef } from "../types";

const seq = column("f1", 100, 70, 92, [
  ["wh", "auto-webhook", "Stripe: payment failed", { props: { sourceSystem: "Stripe" } }],
  ["e1", "auto-email", "Your card didn't go through", { props: { subject: "Quick fix: your payment needs a new card" } }],
  ["w1", "auto-wait", "Wait 2 days", { props: { duration: "2", unit: "days" } }],
  ["e2", "auto-email", "Retry #2 — update your card", { props: { subject: "Second try failed — one tap to fix" } }],
  ["s1", "auto-sms", "Heads up by text", { props: { message: "Your ___ payment didn't go through. Update here: {{link.billing}}" } }],
  ["w2", "auto-wait", "Wait 3 days", { props: { duration: "3", unit: "days" } }],
  ["e3", "auto-email", "Final notice before pause", { props: { subject: "Access pauses Friday unless we hear from you" } }],
  ["c1", "auto-condition", "Payment recovered?", { props: { condition: "Has tag 'payment-recovered'" } }],
  ["tg", "auto-tag-add", "Tag: involuntary-churn", { props: { tag: "involuntary-churn" } }],
]);

const def: TemplateDef = {
  slug: "failed-payment-dunning",
  name: "Failed Payment Dunning",
  category: "SaaS",
  tagline:
    "Recover the churn nobody chose — three retries, one text, and a dated deadline.",
  description:
    "A free dunning sequence template: a Stripe payment-failed webhook starts a three-email plus SMS recovery ladder pointing at an update-card page, with a deadline email and an involuntary-churn tag if it never lands. Clone it into FrazzleCRM and it runs against your real billing webhooks.",
  whatsInside: [
    "Inbound webhook entry wired for a Stripe invoice.payment_failed event",
    "Three escalating emails plus one SMS across five days",
    "Update-card checkout page as the single call to action",
    "Recovered? branch, and an involuntary-churn tag when it isn't",
  ],
  flow: makeFlow(
    [
      node("st", "prov-stripe", "Stripe", 40, 140),
      flow("f1", "Dunning Ladder", 360, 40, 420, 948),
      ...seq.nodes,
      node("co", "page-checkout", "Update card", 880, 260, { props: { price: "Same plan" } }),
      node("out", "outcome-sale", "Payment recovered", 1200, 260),
      node("n1", "util-note", "Involuntary churn is the cheap kind", 40, 340, {
        notes:
          "These people already decided to pay you — the card just expired. A dunning sequence typically recovers a large share of failed charges for the cost of four messages.",
      }),
    ],
    [
      edge("st", "f1"),
      ...seq.edges,
      edge("f1", "co"),
      edge("co", "out"),
    ]
  ),
};

export default def;
